<script>
    import {
        BackArrow,
        CreatePresetModal,
        Loader,
        NotificationModal,
        OcrStickerModal,
        CustomTooltip,
    } from "../../../Components/Common/index.svelte";
    import InsuranceValidationInfo from "../../../Components/Custom/Table/Components/EncounterTable/InsuranceValidationInfo.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import {
        EncounterSidePanelProps,
        preventRedirect,
        preventRedirectObj,
        user,
        isMobile
    } from "../../../stores";

    import {
        checkPatientPaidPaymentsViaChangeEncounterStatus,
        headerRightBtnCls,
        NoteTypes,
    } from "../../../Utils/utilConstants.svelte";

    import {
    DirectEncounterStatus,
        DirectUserRoles,
        encounterStatus,
    } from "../../../Utils/utilEnums.svelte";

    import {
        getDisplayPatientName,
        getEncounterStatus,
        getFormatDate,
        getGenderType,
        getYearsOrMonthsOld,
        goBack,
        goToURL,
        getBillingStatus,
        showError,
        showException,
        getEncounterBillingType,
        isObjectEmpty,
        getTitle,
        getFormatDateAndTime,
        copyObjContent,
    } from "../../../Utils/utilFunctions.svelte";

    import {
        getEncounterMissingProperties,
        _getDisplayDate,
        _getDoctorFullName,
        getOcrText,
        _getSurgeonFullName,
    } from "../helpers/encounterHelper.svelte";
    import { getUnderAndOverPaymentProperties } from "../helpers/encounterUtils.svelte";

    import ViewEncounterListModal from "./ViewEncounterListModal.svelte";
    import CommunicationToggle from "../../../Components/Common/CommunicationToggle.svelte";
    import { onMount } from "svelte";
    import PaymentTag from "../../../Components/Common/PaymentTag.svelte";

    export let patientEncounter = {};
    export let patientDetails = {};
    export let procedureDetails = {};
    export let paymentsData = [];
    export let isLoadingPatientEncounter = true;
    export let isNotesInEdit = false;
    export let isPatientQuote = false;
    export let isFromCalendarList = false;
    export let callbackFunc = () => {};
    export let reloadPatientEncounter = () => {};

    onMount(async () => {
       await loadHeader();
    });

    $: displayProcedureDetails = _getDisplayProcedureText(patientEncounter);

    $: displaySurgeonAndHospitalDetails = _getDisplaySurgeonAndHospitalText(
        procedureDetails,
        patientEncounter,
    );

    $: showCommunicationToggle = !isObjectEmpty(patientEncounter) && !$isMobile;

    $: displayHospitalDetails = _getDisplayHospitalText(procedureDetails);

    $: encounterDoctorId = patientEncounter.doctor?.id;

    $: isUserEnableUpdatePatientEncounterStatus =
        $user.role >= 2 && $user.role != DirectUserRoles.Developer;

    $: encounterEnableSaveAsPreset =
        patientEncounter.billingStatus == 5 && !patientEncounter.quoteOnly;

    $: if (patientEncounter.updatedByOCRDate)
        ocrText = getOcrText(patientEncounter.updatedByOCRDate);

    $: displayPatientName = _getPatientName(patientDetails);
    $: displayGenderAge = _getGenderAndAge(patientDetails);

    $: encounterUnderOrOverPayment = getUnderAndOverPaymentProperties(patientEncounter);

    $: encounterMissingProperties =
        getEncounterMissingProperties(patientEncounter);

    $: isAgreementHospitalFund = patientEncounter.isAgreementHospitalFund;

    let isOcrStickerModalOpen = false,
        isEncounterListModalOpen = false;

    let isSavePresetModalOpen = false,
        isSuccessSavePresetModalOpen = false;

    let isUpdatingEncounterStatus = false;

    let ocrText = "";

    let isChangingStatusOptionsOpen = false;

    let isConfirmUpdateEncounterStatusModalOpen = false,
        newStatus = null;

    let encounterHasActiveClaim = false,
        encounterHasActiveClaimStatus = false,
        encounterHasActiveClaimEraStatus = false;

    let encounterHasPatientPaidPayments = false,
        isConfirmCancelEncounterWithPatientPaidPaymentsModalOpen = false;

    let patientTagRef, insuranceTagRef;

    const checkClaimStatusViaChangeStatus = [7, 8, 9];

    export const loadHeader = async () => {
        if(patientEncounter.doctor)
            await loadDoctorNotes();

        if(patientTagRef?.load) {
            patientTagRef.load();
        }

        if(insuranceTagRef?.load) {
            insuranceTagRef?.load();
        }
    }

    const showOcrStickerModal = () => (isOcrStickerModalOpen = true);

    const openEncounterListModal = () => {
        if (encounterDoctorId && patientEncounter.id)
            isEncounterListModalOpen = true;
    };

    const showSavePresetModal = () => (isSavePresetModalOpen = true);

    const closeSavePresetModal = (showCompleteModal = false) => {
        isSavePresetModalOpen = false;
        isSuccessSavePresetModalOpen = showCompleteModal;
    };

    const duplicateEncounter = () => {
        $preventRedirectObj.showModal = $preventRedirect;

        if (isNotesInEdit)
            callbackFunc = () =>
                goToURL(
                    `/${isPatientQuote ? "PatientQuote" : "PatientEncounter"}/edit/${patientEncounter.id}/isDuplicate=2`,
                );
        else if (isFromCalendarList)
            $EncounterSidePanelProps.type = "duplicate";
        else
            goToURL(
                `/${isPatientQuote ? "PatientQuote" : "PatientEncounter"}/edit/${patientEncounter.id}/isDuplicate=2`,
            );
    };

    const confirmDeletePatientEncounter = async () => {
        await apiMethods.deleteMethod
            .deletePatientEncounter(patientEncounter.id)
            .then(async (res) => {
                if (res.id) await reloadPatientEncounter();
                else if (
                    res.error &&
                    res.error.includes("Encounter has a claim")
                ) {
                    showError(
                        "For purposes of auditing, we are unable to archive encounters with an active claim.",
                        undefined,
                        true,
                    );
                } else {
                    showError(
                        `Failed to archive this patient encounter, please try again later or contact for support...\n${res.error}`,
                        undefined,
                        true,
                    );
                }
            })
            .catch((err) =>
                showException(
                    `Failed to archive this patient encounter, please try again later or contact for support...\n${err}`,
                    undefined,
                    true,
                ),
            );
    };

    const confirmUnArchivePatientEncounter = async () => {
        await apiMethods.putMethod
            .unDeletePatientEncounter(patientEncounter.id)
            .then(async (res) => {
                if (res.id) await reloadPatientEncounter();
                else
                    showError(
                        `Failed to un-archive this patient encounter, please refresh the page and try again and contact support if the issue persists. \n${res.error}`,
                    );
            })
            .catch((err) =>
                showException(
                    `Failed to un-archive this patient encounter, please refresh the page and try again and contact support if the issue persists. \n${err}`,
                ),
            );
    };

    const handleUpdateStatus = async (addSkipRefundToUrl = false) => {
        if (isUpdatingEncounterStatus) return;

        isUpdatingEncounterStatus = true;

        if (checkClaimStatusViaChangeStatus.includes(newStatus)) {
            if (encounterHasActiveClaim) {
                encounterHasActiveClaimStatus &&
                    (await apiMethods.putMethod.updateClaimStatus(
                        patientEncounter.id,
                        10,
                    ));
                encounterHasActiveClaimEraStatus &&
                    (await apiMethods.putMethod.updateClaimEraStatus(
                        patientEncounter.id,
                        10,
                    ));
            }

            if (
                checkPatientPaidPaymentsViaChangeEncounterStatus.includes(
                    newStatus,
                ) &&
                encounterHasPatientPaidPayments &&
                addSkipRefundToUrl
            )
                await cancelEncounterWithPatientPayment();
            else await updateEncounterStatus(newStatus);
        } else if (newStatus == 0 && patientEncounter.newStatus == 9)
            // restore deleted encounter back to active status
            await confirmUnArchivePatientEncounter();
        else await updateEncounterStatus(newStatus);

        isUpdatingEncounterStatus = false;

        _closeConfirmUpdateEncounterStatusModal();

        // reload calendar info after close side panel
        if (isFromCalendarList)
            $EncounterSidePanelProps.shouldTriggerCloseFunction = true;
    };

    const updateEncounterStatus = async (status) => {
        if (status != 9)
            await apiMethods.putMethod
                .updateEncounterStatus(patientEncounter.id, status)
                .then(async (res) => {
                    if (!res || res.error)
                        showError(
                            res.error ??
                                "Failed to update encounter status, please refresh the page and try again and contact support if the issue persists.",
                        );
                    else reloadPatientEncounter();
                });
        else await confirmDeletePatientEncounter();
    };

    const cancelEncounterWithPatientPayment = async () => {
        await apiMethods.putMethod
            .cancelEncounterWithoutRefund(patientEncounter.id)
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to cancel encounter, please refresh the page and try again and contact support if the issue persists.",
                    );
                else reloadPatientEncounter();
            });
    };

    // HELPER FUNCTIONS
    const _getDisplayProcedureText = (encounter = {}) => {
        const { typeOfBill, procedureName } = encounter;

        const MAX_DESCRIPTION_CHAR = 120;

        const displayProcedureText =
            procedureName?.length > MAX_DESCRIPTION_CHAR
                ? procedureName.slice(0, MAX_DESCRIPTION_CHAR) + "..."
                : procedureName;

        let res = "";

        res = `${getEncounterBillingType(typeOfBill)}, ${displayProcedureText}`;

        return res;
    };

    const _getDisplaySurgeonAndHospitalText = (
        procedure = {},
        encounter = {},
    ) => {
        const { surgeon, scheduledDate } = procedure;

        let res = "";

        const hasValidSurgeonDetails = surgeon && !isObjectEmpty(surgeon);

        const hasValidScheduledDate =
            scheduledDate &&
            !isNaN(scheduledDate.split("-")[0]) &&
            Number(scheduledDate.split("-")[0]) >= 1900;

        if (hasValidSurgeonDetails) {
            const {
                title: surgeonTitle,
                firstName: surgeonFirstName,
                lastName: surgeonLastName,
            } = surgeon;

            res += `With ${getTitle(surgeonTitle)} ${surgeonFirstName} ${surgeonLastName}`;

            if (encounter.doctorProvider) {
                const {
                    doctorProvider: { number: doctorProviderNumber },
                } = encounter;

                res += ` (${doctorProviderNumber})`;
            }
        }

        if (hasValidScheduledDate)
            res += ` ${hasValidSurgeonDetails ? "on" : "On"} ${getFormatDateAndTime(scheduledDate)}`;

        return res;
    };

    const _getDisplayHospitalText = (procedure = {}) => {
        const { hospital } = procedure;

        let res = "";

        const hasValidHospitalDetails = hospital && !isObjectEmpty(hospital);

        if (hasValidHospitalDetails) {
            const { name: hospitalName } = hospital;

            res += `At ${hospitalName}`;
        }

        return res;
    };

    const _getPatientName = (patient = {}) => {
        const patientName = getDisplayPatientName(patient);

        return `${patientName}`;
    };

    const _getGenderAndAge = (patient = {}) => {
        const { sex, birthDate } = patient;

        const gender = sex == 2 ? "Not specified" : getGenderType(sex);

        return `${gender}, ${getYearsOrMonthsOld(birthDate)}`;
    }

    const _showStatusMenu = () => {
        if (document.getElementById("encounterStatusDropDownMenu")) {
            document.getElementById(
                "encounterStatusDropDownMenu",
            ).style.display = "flex";
            isChangingStatusOptionsOpen = true;
        }
    };

    const _hideStatusMenu = () => {
        if (document.getElementById("encounterStatusDropDownMenu")) {
            document.getElementById(
                "encounterStatusDropDownMenu",
            ).style.display = "none";
            isChangingStatusOptionsOpen = false;
        }
    };

    const _getStatusBackgroundColor = (status) => {
        if (status == 9) return "bg-error";
        if (status == 0) return "";
        return "bg-warning";
    };

    const _openConfirmUpdateEncounterStatusModal = (status) => {
        _hideStatusMenu();
        newStatus = status;

        _determineArchiveWithActiveClaim();

        _determineCancelWithPatientPaidPayments();

        if (
            encounterHasPatientPaidPayments &&
            checkPatientPaidPaymentsViaChangeEncounterStatus.includes(newStatus)
        )
            isConfirmCancelEncounterWithPatientPaidPaymentsModalOpen = true;
        else isConfirmUpdateEncounterStatusModalOpen = true;
    };

    const _closeConfirmUpdateEncounterStatusModal = () => {
        newStatus = null;
        isConfirmUpdateEncounterStatusModalOpen = false;
        isConfirmCancelEncounterWithPatientPaidPaymentsModalOpen = false;
    };

    const _determineArchiveWithActiveClaim = () => {
        const { claimERAStatus, claimStatus, claimTransactionId } =
            patientEncounter;

        encounterHasActiveClaimStatus = ![5, 10].includes(claimStatus);
        encounterHasActiveClaimEraStatus = ![2, 10].includes(claimERAStatus);

        encounterHasActiveClaim = checkClaimStatusViaChangeStatus.includes(
            newStatus,
        )
            ? !!claimTransactionId &&
              (encounterHasActiveClaimStatus ||
                  encounterHasActiveClaimEraStatus)
            : false;
    };

    const _determineCancelWithPatientPaidPayments = () => {
        if (!paymentsData) encounterHasPatientPaidPayments = false;
        else
            encounterHasPatientPaidPayments = paymentsData.some(
                ({ paidBy, status }) => paidBy == 0 && [1, 2].includes(status),
            );
    };

    var doctorNote = "";

    const loadDoctorNotes = async () => {
        await apiMethods.getMethod
            .getNotes(NoteTypes.Account, patientEncounter.doctor.id)
            .then((res) => {
                if(res.results.length > 0) {
                    doctorNote = res.results.map((n) => n.content).join("<br/><br/>");
                }
            })
            .catch((err) => {
                showError(err);
            });

    };
</script>

<div>
    {#if $isMobile}
        <div class="flex gap-2 items-center justify-between pb-2">
           
            <div class="flex flex-1 gap-2">
                {#if !isFromCalendarList}
                    <div class="pt-1">
                        <BackArrow
                            backFunc={isNotesInEdit
                                ? () => {
                                    $preventRedirectObj.showModal = $preventRedirect;

                                    callbackFunc = () => goBack();
                                }
                                : goBack}
                        />
                    </div>
                {/if}

                <div class="flex flex-col">
                    <div class="inline-block align-middle">
                        <span class="align-middle font-bold">
                            {isPatientQuote ? "Fee Estimate" : "Encounter"}
                            {patientEncounter.id} - {displayPatientName}
                        </span>

                        <CustomTooltip zIndex={5}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                class="stroke-secondary h-6 w-6 cursor-helper"
                                slot="tooltipTrigger"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>

                            <div class="flex flex-col gap-y-1">
                                <p>{displayProcedureDetails}</p>
                                <p>{displaySurgeonAndHospitalDetails}</p>
                                <p>{displayHospitalDetails}</p>
                            </div>
                        </CustomTooltip>

                        {#if ocrText}
                            <span class="align-middle text-xs">{ocrText}</span>
                        {/if}
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <!-- svelte-ignore a11y-no-static-element-interactions -->
                        <span
                            class="cursor-pointer hover:underline font-extrabold text-secondary align-middle text-xs"
                            on:click|preventDefault={openEncounterListModal}
                        >
                            View Encounter List
                        </span>
                    </div>
                </div>
            </div>

            <div class="flex flex-1 flex-col justify-start items-end h-full">
                <div class="flex flex-wrap gap-2 items-start justify-end">
                    {#if patientEncounter.isDeleted}
                        <p class="text-error font-bold pt-1">
                            Archived on {getFormatDate(patientEncounter.deletedDate)}
                        </p>
                    {/if}

                    {#if !isLoadingPatientEncounter}
                        {#if isUserEnableUpdatePatientEncounterStatus}
                            <!-- svelte-ignore a11y-no-static-element-interactions -->
                            <div class="flex-none" on:mouseleave={_hideStatusMenu}>
                                <div class="menu menu-horizontal">
                                    <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
                                    <li tabindex="0" on:mousemove={_showStatusMenu}>
                                        <div
                                            class={`${headerRightBtnCls} ${_getStatusBackgroundColor(patientEncounter.status)} flex items-center ${isChangingStatusOptionsOpen ? "rounded-t-lg" : "rounded-lg"}`}
                                        >
                                            {#if isUpdatingEncounterStatus}
                                                <Loader size="1rem" />
                                            {/if}
                                            <p>
                                                {getEncounterStatus(
                                                    patientEncounter.status,
                                                )}
                                            </p>
                                            <svg
                                                class="fill-current"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                ><path
                                                    d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                                /></svg
                                            >
                                        </div>

                                        <ul
                                            id="encounterStatusDropDownMenu"
                                            class="z-[1000] dropdown-content menu border-0 bg-zinc-300 w-48 rounded-b-lg overflow-hidden"
                                        >
                                            <div>
                                                {#each encounterStatus as { id, type }}
                                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                                    <div
                                                        class={`flex items-center justify-start p-4 gap-x-2 border-0 h-12 cursor-pointer ${id == patientEncounter.status ? "bg-secondary text-white" : "bg-zinc-200 text-[#6f726c] hover:bg-zinc-300"}`}
                                                        on:click|preventDefault={() =>
                                                            _openConfirmUpdateEncounterStatusModal(
                                                                id,
                                                            )}
                                                    >
                                                        {type}
                                                    </div>
                                                {/each}
                                            </div>
                                        </ul>
                                    </li>
                                </div>
                            </div>
                        {/if}

                        <button
                            class={headerRightBtnCls}
                            on:click={showOcrStickerModal}
                        >
                            <i class="fa-solid fa-image" />
                            Sticker
                        </button>

                        {#if encounterEnableSaveAsPreset}
                            <button
                                class={headerRightBtnCls}
                                on:click={showSavePresetModal}
                            >
                                <i class="fa-solid fa-notes-medical" />
                                Save as Preset
                            </button>
                        {/if}

                        <button class={headerRightBtnCls} on:click={duplicateEncounter}>
                            <i class="fa fa-clone" />
                            Duplicate
                        </button>
                    {/if}
                </div>
            </div>
        </div>
    {:else}
        <div class="flex flex-col gap-1 mb-2">
            <div class="flex flex-col gap-2 shadow-2xl rounded-lg bg-white ">
                <div class="flex flex-row justify-between gap-2 border-b border-b-gray-300 pl-4 pr-4 pt-2 pb-2">
                    <div class="flex-1 flex gap-2 items-center">
                        {#if !isFromCalendarList}
                            <div class="text-xs pr-4">
                                <BackArrow
                                    backFunc={isNotesInEdit
                                        ? () => {
                                            $preventRedirectObj.showModal = $preventRedirect;

                                            callbackFunc = () => goBack();
                                        }
                                        : goBack}
                                />
                            </div>
                        {/if}
                        <div class="font-bold">
                            {isPatientQuote ? "Fee Estimate" : "Encounter"} {patientEncounter.id}:
                        </div>
                        
                        <div class="font-bold">
                            {displayPatientName}
                        </div>
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <!-- svelte-ignore a11y-no-static-element-interactions -->
                        <div title="Click to copy"
                            class="copyIcon fa-regular fa-copy text-[14px] hover:cursor-pointer" 
                            on:click={() => copyObjContent(`${patientEncounter.id} ${displayPatientName}`, "Encounter id and name successfully copied to clipboard")}>
                        </div>
                        <div class="pl-2 pr-2 pt-1 pb-1 bg-gray-100 rounded text-sm" >
                            <CustomTooltip
                                contentClass="bg-[#fff] border-none"
                                contentStyle="box-shadow: 4px 4px 13.7px 1px rgba(0, 0, 0, 0.25);"
                            >
                                <p slot="tooltipTrigger">
                                    {displayGenderAge}
                                </p>

                                Patient birth date: {_getDisplayDate(patientEncounter.patient.birthDate)}
                            </CustomTooltip>
                        </div>
                        <div class="pl-2 pr-2 pt-1 pb-1 rounded text-sm" style={`background: ${getBillingStatus(patientEncounter.billingStatus, 'color')}; color:white`}>
                            {getBillingStatus(patientEncounter.billingStatus, 'type')}
                        </div>
                        {#if patientEncounter.isNoGapProgram}
                            <div
                                class="pl-2 pr-2 pt-1 pb-1 rounded text-sm text-white border bg-[#63c567] rounded"
                            >
                                <CustomTooltip
                                        contentClass="bg-[#fff] border-none"
                                        contentStyle="box-shadow: 4px 4px 13.7px 1px rgba(0, 0, 0, 0.25);"
                                    >
                                    <p slot="tooltipTrigger">
                                        NO GAP PROGRAM ACTIVE
                                    </p>
                                    No Gap Hospital Program Active (This encounter qualifies for {patientDetails.insuranceName}’s No Gap Program at {patientEncounter.hospital?.name}. Billing rules are set. If this is incorrect, please contact Anaemate support)
                                </CustomTooltip>
                            </div>
                        {/if}
                    </div>
                    <div class="flex gap-2 justify-end items-center">
                        <div class="text-sm">
                            Doctor: <b>{_getDoctorFullName(patientEncounter.doctor)}</b>
                        </div>
                        {#if doctorNote != ""}
                            <CustomTooltip 
                                zIndex={999}
                                contentClass="max-h-60 overflow-y-auto overflow-x-hidden min-w-0"
                                tooltipPosition="left">
                                <div class="cursor-pointer" slot="tooltipTrigger">
                                    <i
                                        class="fa-solid fa-circle-info"
                                    >
                                    </i>
                                </div>
                            
                                <p class="m-0 break-words [overflow-wrap:anywhere] hyphens-auto">{@html doctorNote}</p>
                            </CustomTooltip>
                        {/if}
                    </div>
                </div>
                <div class="flex flex-row gap-2 justify-between pl-4 pr-4 pb-2">
                    <div class="flex-1 flex flex-col gap-1">
                        <div class="text-sm">
                            {#if patientEncounter.procedureName}
                                {patientEncounter.procedureName}
                            {:else}
                                <i class="text-gray-300">No procedure defined</i>
                            {/if}
                        </div>
                        <div class="text-sm">
                            {patientEncounter.scheduledDate ? _getDisplayDate(patientEncounter.scheduledDate) : "No scheduled date"}, {patientEncounter.surgeon ? _getSurgeonFullName(patientEncounter.surgeon) : "No surgeon"}, {patientEncounter.hospital ? patientEncounter.hospital.name : "No hospital"}
                        </div>
                    </div>
                    <div class="flex flex-col gap-2 justify-start items-end">
                        <div class="pt-2 flex flex-row gap-x-4 items-center">
                            {#if patientEncounter}
                                 {#if showCommunicationToggle}
                                    <div class="flex flex-row gap-x-2">
                                        <p class="title">Disable communication:</p>
                                        <p class="content">
                                            <CommunicationToggle
                                                showLabel={false}
                                                patientEncounter={patientEncounter}
                                                on:disableNotificationsToggled={() =>
                                                    (patientEncounter.disableNotifications =
                                                        !patientEncounter.disableNotifications)}
                                            />
                                        </p>
                                    </div>
                                {/if}
                                <PaymentTag
                                    bind:this={patientTagRef}
                                    bind:encounterDetails={patientEncounter}
                                    onSaveCompleted={() => {}}
                                    tagId={patientEncounter.patientPaymentTag}
                                    type="Patient"
                                    witdhHeight={25}
                                ></PaymentTag>

                                <PaymentTag
                                    bind:this={insuranceTagRef}
                                    bind:encounterDetails={patientEncounter}
                                    onSaveCompleted={() => {}}
                                    tagId={patientEncounter.insurancePaymentTag}
                                    type="Insurance"
                                    witdhHeight={25}
                                ></PaymentTag>
                            {/if}
                            <InsuranceValidationInfo fromHeader={true} bind:row={patientEncounter}></InsuranceValidationInfo>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
</div>

{#if encounterMissingProperties.length}
    <div
        class="flex flex-wrap items-center mb-2 p-2 gap-x-2 w-full border bg-rose-600 border-2 rounded-lg"
    >
        {#each encounterMissingProperties as missingText, index}
            <span class="text-white cursor-default">
                {missingText}{index != encounterMissingProperties.length - 1
                    ? ", "
                    : ""}
            </span>
        {/each}
    </div>
{/if}

{#if !isAgreementHospitalFund}
    <div class="flex flex-wrap items-center mb-2 p-2 gap-x-2 w-full border bg-orange-600 border-2 rounded-lg">
        <span class="text-white cursor-default">
            {#if patientEncounter.hospital == null}
                {patientDetails.insuranceName} does not cover procedures outside a recognised hospital facility. Rebates are likely to be 75-85% of the Medicare Schedule Fee depending on the facility. {patientEncounter.patient?.insuranceType == 0 ? "Please change the insurance type to Self Insured on this encounter to show rebates as 75% of MBS Fee." : ""}
            {:else}
                {patientDetails.insuranceName} does not have an agreement with {patientEncounter.hospital?.name}. Rebates are limited to the Medicare Schedule Fee.
            {/if}
        </span>
    </div>
{/if}

<OcrStickerModal
    bind:isModalOpen={isOcrStickerModalOpen}
    encounterId={patientEncounter.id}
    accountId={encounterDoctorId}
/>

<NotificationModal
    isModalOpen={isSuccessSavePresetModalOpen}
    closeModal={() => closeSavePresetModal()}
    closeModalFunction={() => closeSavePresetModal()}
    showConfirmBtn={false}
    title="done"
>
    <div class="flex gap-x-4 items-center leading-6">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="stroke-current flex-shrink-0 h-6 w-6 text-secondary"
            fill="none"
            viewBox="0 0 24 24"
            ><path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            /></svg
        >
        <p>Preset successfully created.</p>
    </div>
</NotificationModal>

{#if isSavePresetModalOpen}
    <CreatePresetModal {patientEncounter} closeModal={closeSavePresetModal} />
{/if}

<NotificationModal
    isModalOpen={isConfirmUpdateEncounterStatusModalOpen}
    title="Update Encounter Status"
    cancelText="Cancel"
    submitText="Confirm"
    confirmButtonClass={newStatus == DirectEncounterStatus.Archived
        ? "btn-error"
        : "btn-secondary"}
    cancelButtonClass="btn-accent"
    closeModal={_closeConfirmUpdateEncounterStatusModal}
    confirmAction={handleUpdateStatus}
    isConfirming={isUpdatingEncounterStatus}
    closeModalFunction={_closeConfirmUpdateEncounterStatusModal}
>
    {#if encounterHasActiveClaim && checkClaimStatusViaChangeStatus.includes(newStatus)}
        <div class="flex flex-col gap-y-2">
            <p>
                Encounter has an active claim. Archiving or cancelling the
                encounter will cancel this active claim.
            </p>
            <p>Do you still wish to proceed?</p>
        </div>
    {:else}
        Change encounter status to {getEncounterStatus(newStatus)}?
    {/if}
</NotificationModal>

<NotificationModal
    isModalOpen={isConfirmCancelEncounterWithPatientPaidPaymentsModalOpen}
    title="Update Encounter Status"
    modalMaxWidth="max-w-xl"
    showCancelBtn={false}
    showConfirmBtn={false}
    closeModalFunction={_closeConfirmUpdateEncounterStatusModal}
    isConfirming={isUpdatingEncounterStatus}
    btnOptions={[
        {
            text: "Cancel",
            class: "btn-accent w-auto",
            loading: isUpdatingEncounterStatus,
            function: () => _closeConfirmUpdateEncounterStatusModal(),
        },
        {
            text: isUpdatingEncounterStatus
                ? "Confirming"
                : "Confirm, No Refund",
            class: "btn-secondary text-xs w-auto",
            loading: isUpdatingEncounterStatus,
            function: () => handleUpdateStatus(true),
        },
        {
            text: isUpdatingEncounterStatus
                ? "Confirming"
                : "Confirm and Refund",
            class: "btn-secondary text-xs w-auto",
            loading: isUpdatingEncounterStatus,
            function: () => handleUpdateStatus(),
        },
    ]}
>
    Change encounter status to Cancelled and refund patient?
</NotificationModal>

<ViewEncounterListModal
    bind:isModalOpen={isEncounterListModalOpen}
    encounterId={patientEncounter.id}
    {encounterDoctorId}
/>

<style>
    .tooltip-doctor-note {
                       
    }
</style>




